import React from 'react';


function FooterComp() {
	return (
		<div>
			
		</div>
	)
}

export default FooterComp